import { useQuery } from '@tanstack/react-query';
import { getUser } from 'api/users';
import LoadingOverlay from 'components/LoadingOverlay';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Sidebar from 'components/Sidebar';
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Settings() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);

    const { data: user, isLoading } = useQuery({
        queryKey: ['users', Cookies.get('oai-user-id')],
        queryFn: async () => await getUser({ id: Cookies.get('oai-user-id') }),
    });

    console.log("user", user, Cookies.get('oai-user-id'));
    return (
        <>
            <LoadingOverlay isLoading={isLoading} />
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <div className='text-center pb-10 pt-20'>
                    <p className='text-3xl'>Impostazioni</p>
                </div>

                <div className='flex flex-wrap gap-4 justify-center px-5'>
                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/account">
                        <p className='text-lg font-medium '>Account</p>
                        <p className='text-muted pt-2'>Gestisci le informazioni del tuo account, come email, password e preferenze di notifica.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/users">
                        <p className='text-lg font-medium '>Utenti</p>
                        <p className='text-muted pt-2'>Gestisci gli utenti del tuo account, inclusi ruoli e autorizzazioni.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/areas">
                        <p className='text-lg font-medium '>Aree</p>
                        <p className='text-muted pt-2'>Gestisci le aree di lavoro per organizzare i tuoi progetti e collaborare con il tuo team.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/offices">
                        <p className='text-lg font-medium '>Uffici</p>
                        <p className='text-muted pt-2'>Gestisci gli uffici associati al tuo account, inclusi indirizzi e dettagli di contatto.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/documents">
                        <p className='text-lg font-medium '>File</p>
                        <p className='text-muted pt-2'>Gestisci i tuoi file.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/models">
                        <p className='text-lg font-medium '>Modelli</p>
                        <p className='text-muted pt-2'>Gestisci i tuoi modelli.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/mcps">
                        <p className='text-lg font-medium '>MCP</p>
                        <p className='text-muted pt-2'>Gestisci i punti di controllo principali (MCP) per monitorare e controllare le operazioni del tuo account.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/documents">
                        <p className='text-lg font-medium '>File</p>
                        <p className='text-muted pt-2'>Gestisci i tuoi file.</p>
                    </Link>


                    {user?.superadmin && <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/gpts">
                        <p className='text-lg font-medium '>GPT</p>
                        <p className='text-muted pt-2'>Gestisci GPT.</p>
                    </Link>}


                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/authtokens">
                        <p className='text-lg font-medium '>Token API</p>
                        <p className='text-muted pt-2'>Crea e gestisci token API per integrazioni esterne.</p>
                    </Link>

                    <Link className='border rounded-sm border-grey p-5 md:max-w-[300px] hover:border-light' to="/settings/publicfile">
                        <p className='text-lg font-medium '>Verifica file pubblico</p>
                    </Link>
                </div>
            </div>
        </>
    )
}
